// dependecies import ==>
import React, { useState } from "react";
import Popover from "react-popover";
// assets and scss import ==>
import "./titleWithBorder.scss";

const TitleWithBorder = (props) => {
  const { title, hoverTitleSize, selected, handleClick } = props;

  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // Actions ==>

  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  // <===

  // Display UI ===>

  const displayTitleWithBorder = () => {
    return (
      <div
        className={
          "title-with-border " + (selected ? "title-with-border-selected" : "")
        }
        onClick={() => (handleClick ? handleClick() : "")}
      >
        {!hoverTitleSize ||
        (hoverTitleSize && title?.trim()?.length <= hoverTitleSize) ? (
          title
        ) : (
          <Popover
            isOpen={isOpen}
            preferPlace={`below`}
            place={null}
            anchorEl={anchorEl}
            body={
              <span style={{ maxWidth: "300px", overflowWrap: "anywhere" }}>
                {title}
              </span>
            }
          >
            <span
              style={{ cursor: "pointer" }}
              onMouseOver={handlePopoverOpen}
              onMouseOut={handlePopoverClose}
            >
              {title
                ?.trim()
                ?.substr(0, hoverTitleSize + 1)
                ?.trim()}
              ...
            </span>
          </Popover>
        )}
      </div>
    );
  };

  // <===

  return (
    <div className="title-with-border-cont">{displayTitleWithBorder()}</div>
  );
};

export default TitleWithBorder;
